import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasV2UnitsSold1PTotalUnitsSoldSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      fieldName="onePUnitsSold"
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      title="1P Units Sold as % of Total"
      marketShareKey={['onePUnitsSold_sum_value', 'unitsSold_sum_value']}
      marketShareBuilder={(rb) => {
        return rb.modifyAggregation((agg) =>
          agg.removeAggregationField('onePUnitsSold').addAggregationField('Units Sold', 'unitsSold', 'sum', true)
        );
      }}
    />
  );
};

export default AtlasV2UnitsSold1PTotalUnitsSoldSplineChart;
